import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import lesson0222 from "../lesson-22/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "788c3cd0-4f3c-4987-a95e-550354cd6501",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0222),
    lesson: lesson0222,
  },
];

export default lessonLinks;
